export const radius = {
  primary: '4px',
}
